




import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../../component/Header.jsx";   // Adjust path as needed
import StaffAssessmentForm from './StaffAssessmentForm';
import { useNavigate } from 'react-router-dom';
import { FaUserTie, FaCalendarAlt, FaEdit, FaTrash, FaEye, FaChartBar } from 'react-icons/fa';
import AssessmentAnalytics from './AssessmentAnalytics.jsx';
import { BiMessageAltAdd } from 'react-icons/bi';
const BASE_URL = `${process.env.REACT_APP_API_URL}assessment`;

const StaffAssessmentPage = () => {
  const currentUser = useSelector((state) => state.user?.currentUser);
const navigate = useNavigate();
  const [scheduledApplicants, setScheduledApplicants] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [selectedAssessment, setSelectedAssessment] = useState(null);   // For viewing full assessment
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showViewAssessmentModal, setShowViewAssessmentModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editingAssessment, setEditingAssessment] = useState(true)
  // Fetch Scheduled Applicants
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch Scheduled Applicants
        const scheduledRes = await fetch(`${process.env.REACT_APP_API_URL}assessment/scheduled-applications`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const scheduledResult = await scheduledRes.json();
        if (scheduledResult.success) {
          setScheduledApplicants(scheduledResult.data || []);
          console.log("Scheduled Applicants:", scheduledResult.data);
        }

        // Fetch All Assessments for this employer
        const assRes = await fetch(`${BASE_URL}/employer`, {   // We'll create this route
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const assResult = await assRes.json();
        if (assResult.success) {
          setAssessments(assResult.data || []);
          console.log(assResult.data);
        }
      } catch (err) {
        console.error("Failed to fetch data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const refreshData = () => {
    window.location.reload();
  };

    const handleViewApplications = (jobId) => {
    if (!jobId) {
      alert("Job ID not found for this application");
      return;
    }
    navigate(`/${jobId}/jobApplicants`);
  };


  const getSeekerName = (application) => {
    const seeker = application?.applicant?.[0] || application?.applicant;
    return seeker
      ? `${seeker.firstName || ""} ${seeker.lastName || ""}`.trim() || "Unnamed"
      : "—";
  };

  const openAssessmentForm = (applicant, existingAss = null) => {
    setSelectedApplicant(applicant);
    setEditingAssessment(existingAss);   // Fixed: was missing this line
    setShowFormModal(true);
  };

  const viewAssessment = (assessment) => {
    setSelectedAssessment(assessment);
    setShowViewAssessmentModal(true);
  };

  const deleteAssessment = async (id) => {
    if (!window.confirm("Delete this assessment permanently?")) return;

    try {
      await fetch(`${BASE_URL}/${id}`, { method: 'DELETE' });
      setAssessments(prev => prev.filter(a => a._id !== id));
      alert("Assessment deleted successfully");
    } catch (err) {
      alert("Failed to delete assessment");
    }
  };

  const getLevelColor = (level) => {
    switch (level) {
      case 'Excellent': return 'bg-green-100 text-green-700';
      case 'Good': return 'bg-blue-100 text-blue-700';
      case 'Fair': return 'bg-yellow-100 text-yellow-700';
      case 'Poor': return 'bg-red-100 text-red-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 pt-20">
        <Header />
        <div className="text-center mt-20 text-lg">Loading assessments...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pt-16 pb-12">
      <Header />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div className="flex justify-between items-center mb-10">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Staff Assessment Center</h1>
            <p className="text-gray-600">Manage all candidate assessments</p>
          </div>
          <Link
            to={`/employer/${currentUser?.currentUser?._id}?tab=jobs`}
            className="px-6 py-3 bg-gray-700 text-white rounded-2xl hover:bg-gray-800 transition"
          >
            ← Back to Dashboard
          </Link>
        </div>

<AssessmentAnalytics assessments={assessments} />

        {/* Completed Assessments */}
        <div className="mb-12">
          <h2 className="text-2xl font-semibold mb-6 flex items-center gap-3">
            <FaChartBar className="text-orange-600" /> Completed Assessments ({assessments.length})
          </h2>

          {assessments.length === 0 ? (
            <div className="bg-white rounded-3xl p-12 text-center border border-dashed border-gray-300">
              <p className="text-gray-500">No assessments completed yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {assessments.map((ass) => (
                <div key={ass._id} className="bg-white rounded-3xl shadow hover:shadow-xl transition-all overflow-hidden border">
                  <div className="h-2 bg-gradient-to-r from-orange-500 to-amber-500" />
                  <div className="p-6">
                    <h3 className="font-semibold text-xl">{ass.applicantName}</h3>
                    <p className="text-orange-600 font-medium">{ass.positionApplied}</p>

                    <div className="mt-6 flex items-center gap-6">
                      <div>
                        <div className="text-5xl font-bold text-gray-900">
                          {ass.percentageScore}<span className="text-2xl text-gray-400">%</span>
                        </div>
                        <p className="text-xs text-gray-500">SCORE</p>
                      </div>
                      <div className={`px-5 py-2 rounded-2xl text-sm font-semibold ${getLevelColor(ass.overallLevel)}`}>
                        {ass.overallLevel}
                      </div>
                    </div>
                  </div>

                  <div className="border-t bg-gray-50 px-6 py-4 flex gap-2">
                    <button 
                      onClick={() => viewAssessment(ass)}
                      className="flex-1 py-3 bg-white border border-gray-300 hover:bg-gray-100 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
                    >
                      <FaEye /> View
                    </button>
                    <button 
                      onClick={() => openAssessmentForm(null, ass)}
                      className="flex-1 py-3 bg-white border border-gray-300 hover:bg-gray-100 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
                    >
                      <FaEdit /> Edit
                    </button>
                    <button 
                      onClick={() => deleteAssessment(ass._id)}
                      className="flex-1 py-3 text-red-600 hover:bg-red-50 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
                    >
                      <FaTrash /> Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Scheduled Candidates */}
        <div>
          <h2 className="text-2xl font-semibold mb-6 flex items-center gap-3">
            <FaCalendarAlt className="text-orange-600" /> Scheduled Candidates ({scheduledApplicants.length})
          </h2>

          <div className="bg-white rounded-3xl shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-6 py-5 text-left">Candidate</th>
                    <th className="px-6 py-5 text-left">Position</th>
                    <th className="px-6 py-5 text-left">Job Title</th>
                    <th className="px-6 py-5 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {scheduledApplicants.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center py-16 text-gray-500">
                        No candidates scheduled for interview yet.
                      </td>
                    </tr>
                  ) : (
                    scheduledApplicants.map((app) => {
                      const existingAss = assessments.find(a => a.applicationId === app._id);

                      return (
                        <tr key={app._id} className="hover:bg-orange-50 transition-colors">
                          <td className="px-6 py-5 font-medium">{getSeekerName(app)}</td>
                          <td className="px-6 py-5">{app.position}</td>
                          <td className="px-6 py-5 text-gray-600">{app.job?.jobTitle || "—"}</td>
                          <td className="px-6 py-5">
                            <div className="flex gap-3 justify-center">
                                    <Link to="/employer/:id?tab=Jobs">
                                          <button
                                onClick={() => { setSelectedApplicant(app); setShowDetailsModal(true); }}
                                className="px-5 py-2 border bg-blue-100 rounded-2xl hover:bg-blue-100 flex items-center gap-2"
                              >
                                <FaEye /> Check Job
                              </button>
                                    </Link>
                             
                                
                              <button
                                onClick={() => { setSelectedApplicant(app); setShowDetailsModal(true); }}
                                className="px-5 py-2 border rounded-2xl hover:bg-gray-100 flex items-center gap-2"
                              >
                                <FaEye /> Details
                              </button>

                              <button
                                onClick={() => openAssessmentForm(app, existingAss)}
                                className={`px-6 py-2 rounded-2xl font-medium transition ${
                                  existingAss 
                                    ? "bg-amber-100 text-amber-700 hover:bg-amber-200" 
                                    : "bg-orange-600 text-white hover:bg-orange-700"
                                }`}
                              >
                                {existingAss ? "Re-Assess" : "Start Assessment"}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      {/* Assessment Form Modal */}
      {showFormModal && selectedApplicant && (
        <StaffAssessmentForm
          applicant={selectedApplicant}
          existingAssessment={editingAssessment}
          currentUser={currentUser}
          onClose={() => setShowFormModal(false)}
          onSaved={refreshData}
          BASE_URL={BASE_URL}
        />
      )}

      {/* Applicant Details Modal */}
      {showDetailsModal && selectedApplicant && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-md w-full p-8">
            <h2 className="text-2xl font-bold mb-6">Applicant Details</h2>
            <div className="space-y-4">
              <p><strong>Name:</strong> {getSeekerName(selectedApplicant)}</p>
              <p><strong>Position:</strong> {selectedApplicant.position}</p>
              <p><strong>Job:</strong> {selectedApplicant.job?.jobTitle || "—"}</p>
              <p><strong>Status:</strong> {selectedApplicant.status}</p>
            </div>
            <button
              onClick={() => setShowDetailsModal(false)}
              className="mt-8 w-full py-3 bg-gray-900 text-white rounded-2xl hover:bg-black"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* View Full Assessment Modal */}
      {showViewAssessmentModal && selectedAssessment && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
            <div className="p-6 border-b bg-orange-50">
              <h2 className="text-2xl font-bold">Assessment Details</h2>
              <p className="text-orange-700">{selectedAssessment.applicantName} - {selectedAssessment.positionApplied}</p>
            </div>
            <div className="p-6 overflow-y-auto max-h-[70vh]">
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div>
                  <p className="text-sm text-gray-500">Score</p>
                  <p className="text-4xl font-bold">{selectedAssessment.percentageScore}%</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Level</p>
                  <p className={`text-3xl font-bold ${getLevelColor(selectedAssessment.overallLevel).replace('bg-', 'text-')}`}>
                    {selectedAssessment.overallLevel}
                  </p>
                </div>

              </div>

              <p className="font-medium mb-2">Comments & Suggestions:</p>
              <p className="text-gray-700 bg-gray-50 p-4 rounded-xl">
                {selectedAssessment.commentsAndSuggestions || "No comments provided."}
              </p>
            </div>
       

  <div className="p-6 border-t bg-gray-50">
              <button
                onClick={() => handleViewApplications(selectedAssessment.jobId || selectedAssessment.application?.job?._id)}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3.5 rounded-2xl font-medium flex items-center justify-center gap-2 transition"
              >
                <BiMessageAltAdd className="w-5 h-5" />
                View All Applications for this Job
              </button>
            </div>

            <div className="p-6 border-t flex justify-end">
              <button
                onClick={() => setShowViewAssessmentModal(false)}
                className="px-8 py-3 bg-gray-900 text-white rounded-2xl hover:bg-black"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffAssessmentPage;






















































// import React, { useState, useEffect } from 'react';
// import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import Header from "../../../component/Header.jsx";
// import StaffAssessmentForm from './StaffAssessmentForm';
// import { useNavigate } from 'react-router-dom';
// import { FaUserTie, FaCalendarAlt, FaEdit, FaTrash, FaEye, FaChartBar } from 'react-icons/fa';
// import AssessmentAnalytics from './AssessmentAnalytics.jsx';
// import { BiMessageAltAdd } from 'react-icons/bi';

// const BASE_URL = `${process.env.REACT_APP_API_URL}assessment`;

// const StaffAssessmentPage = () => {
//   const currentUser = useSelector((state) => state.user?.currentUser);
//   const navigate = useNavigate();

//   const [scheduledApplicants, setScheduledApplicants] = useState([]);
//   const [assessments, setAssessments] = useState([]);
//   const [selectedApplicant, setSelectedApplicant] = useState(null);
//   const [selectedAssessment, setSelectedAssessment] = useState(null);
//   const [showDetailsModal, setShowDetailsModal] = useState(false);
//   const [showFormModal, setShowFormModal] = useState(false);
//   const [showViewAssessmentModal, setShowViewAssessmentModal] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [editingAssessment, setEditingAssessment] = useState(null);

//   // Fetch Data
//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         // Fetch Scheduled Applicants
//         const scheduledRes = await fetch(`${process.env.REACT_APP_API_URL}assessment/scheduled-applications`, {
//           headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
//         });
//         const scheduledResult = await scheduledRes.json();
//         if (scheduledResult.success) {
//           setScheduledApplicants(scheduledResult.data || []);
//         }

//         // Fetch All Assessments
//         const assRes = await fetch(`${BASE_URL}/employer`, {
//           headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
//         });
//         const assResult = await assRes.json();
//         if (assResult.success) {
//           setAssessments(assResult.data || []);
//         }
//       } catch (err) {
//         console.error("Failed to fetch data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const refreshData = () => {
//     window.location.reload();
//   };

//   const getSeekerName = (application) => {
//     const seeker = application?.applicant?.[0] || application?.applicant;
//     return seeker
//       ? `${seeker.firstName || ""} ${seeker.lastName || ""}`.trim() || "Unnamed"
//       : "—";
//   };

//   const openAssessmentForm = (applicant, existingAss = null) => {
//     setSelectedApplicant(applicant);
//     setEditingAssessment(existingAss);
//     setShowFormModal(true);
//   };

//   const viewAssessment = (assessment) => {
//     setSelectedAssessment(assessment);
//     setShowViewAssessmentModal(true);
//   };

//   const deleteAssessment = async (id) => {
//     if (!window.confirm("Delete this assessment permanently?")) return;

//     try {
//       await fetch(`${BASE_URL}/${id}`, { method: 'DELETE' });
//       setAssessments(prev => prev.filter(a => a._id !== id));
//       alert("Assessment deleted successfully");
//     } catch (err) {
//       alert("Failed to delete assessment");
//     }
//   };

//   const getLevelColor = (level) => {
//     switch (level) {
//       case 'Excellent': return 'bg-green-100 text-green-700';
//       case 'Good': return 'bg-blue-100 text-blue-700';
//       case 'Fair': return 'bg-yellow-100 text-yellow-700';
//       case 'Poor': return 'bg-red-100 text-red-700';
//       default: return 'bg-gray-100 text-gray-700';
//     }
//   };

//   // Navigate to Applicant List for this specific Job
//   const handleViewApplications = (jobId) => {
//     if (!jobId) {
//       alert("Job ID not found for this application");
//       return;
//     }
//     navigate(`/${jobId}/jobApplicants`);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 pt-20">
//         <Header />
//         <div className="text-center mt-20 text-lg">Loading assessments...</div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 pt-16 pb-12">
//       <Header />

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
//         <div className="flex justify-between items-center mb-10">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-900">Staff Assessment Center</h1>
//             <p className="text-gray-600">Manage all candidate assessments</p>
//           </div>
//           <Link
//             to={`/employer/${currentUser?.currentUser?._id}?tab=jobs`}
//             className="px-6 py-3 bg-gray-700 text-white rounded-2xl hover:bg-gray-800 transition"
//           >
//             ← Back to Dashboard
//           </Link>
//         </div>

//         <AssessmentAnalytics assessments={assessments} />

//         {/* Completed Assessments */}
//         <div className="mb-12">
//           <h2 className="text-2xl font-semibold mb-6 flex items-center gap-3">
//             <FaChartBar className="text-orange-600" /> Completed Assessments ({assessments.length})
//           </h2>

//           {assessments.length === 0 ? (
//             <div className="bg-white rounded-3xl p-12 text-center border border-dashed border-gray-300">
//               <p className="text-gray-500">No assessments completed yet.</p>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//               {assessments.map((ass) => (
//                 <div key={ass._id} className="bg-white rounded-3xl shadow hover:shadow-xl transition-all overflow-hidden border">
//                   <div className="h-2 bg-gradient-to-r from-orange-500 to-amber-500" />
//                   <div className="p-6">
//                     <h3 className="font-semibold text-xl">{ass.applicantName}</h3>
//                     <p className="text-orange-600 font-medium">{ass.positionApplied}</p>

//                     <div className="mt-6 flex items-center gap-6">
//                       <div>
//                         <div className="text-5xl font-bold text-gray-900">
//                           {ass.percentageScore}<span className="text-2xl text-gray-400">%</span>
//                         </div>
//                         <p className="text-xs text-gray-500">SCORE</p>
//                       </div>
//                       <div className={`px-5 py-2 rounded-2xl text-sm font-semibold ${getLevelColor(ass.overallLevel)}`}>
//                         {ass.overallLevel}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="border-t bg-gray-50 px-6 py-4 flex gap-2">
//                     <button 
//                       onClick={() => viewAssessment(ass)}
//                       className="flex-1 py-3 bg-white border border-gray-300 hover:bg-gray-100 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
//                     >
//                       <FaEye /> View
//                     </button>
//                     <button 
//                       onClick={() => openAssessmentForm(null, ass)}
//                       className="flex-1 py-3 bg-white border border-gray-300 hover:bg-gray-100 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
//                     >
//                       <FaEdit /> Edit
//                     </button>
//                     <button 
//                       onClick={() => deleteAssessment(ass._id)}
//                       className="flex-1 py-3 text-red-600 hover:bg-red-50 rounded-2xl text-sm font-medium flex items-center justify-center gap-2"
//                     >
//                       <FaTrash /> Delete
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Scheduled Candidates Table */}
//         <div>
//           <h2 className="text-2xl font-semibold mb-6 flex items-center gap-3">
//             <FaCalendarAlt className="text-orange-600" /> Scheduled Candidates ({scheduledApplicants.length})
//           </h2>

//           <div className="bg-white rounded-3xl shadow overflow-hidden">
//             <div className="overflow-x-auto">
//               <table className="w-full">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-6 py-5 text-left">Candidate</th>
//                     <th className="px-6 py-5 text-left">Position</th>
//                     <th className="px-6 py-5 text-left">Job Title</th>
//                     <th className="px-6 py-5 text-center">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y">
//                   {scheduledApplicants.length === 0 ? (
//                     <tr>
//                       <td colSpan="4" className="text-center py-16 text-gray-500">
//                         No candidates scheduled for interview yet.
//                       </td>
//                     </tr>
//                   ) : (
//                     scheduledApplicants.map((app) => {
//                       const existingAss = assessments.find(a => a.applicationId === app._id);

//                       return (
//                         <tr key={app._id} className="hover:bg-orange-50 transition-colors">
//                           <td className="px-6 py-5 font-medium">{getSeekerName(app)}</td>
//                           <td className="px-6 py-5">{app.position}</td>
//                           <td className="px-6 py-5 text-gray-600">{app.job?.jobTitle || app.job?.title || "—"}</td>
//                           <td className="px-6 py-5">
//                             <div className="flex gap-3 justify-center flex-wrap">
//                               <button
//                                 onClick={() => { setSelectedApplicant(app); setShowDetailsModal(true); }}
//                                 className="px-5 py-2 border bg-blue-100 rounded-2xl hover:bg-blue-200 flex items-center gap-2 text-sm"
//                               >
//                                 <FaEye /> Details
//                               </button>

//                               <button
//                                 onClick={() => openAssessmentForm(app, existingAss)}
//                                 className={`px-6 py-2 rounded-2xl font-medium transition text-sm ${
//                                   existingAss 
//                                     ? "bg-amber-100 text-amber-700 hover:bg-amber-200" 
//                                     : "bg-orange-600 text-white hover:bg-orange-700"
//                                 }`}
//                               >
//                                 {existingAss ? "Re-Assess" : "Start Assessment"}
//                               </button>

//                               {/* New: View Applications Button */}
//                               {app.job?._id && (
//                                 <button
//                                   onClick={() => handleViewApplications(app.job._id)}
//                                   className="px-5 py-2 border border-orange-600 text-orange-600 rounded-2xl hover:bg-orange-50 flex items-center gap-2 text-sm font-medium"
//                                 >
//                                   <BiMessageAltAdd className="w-4 h-4" />
//                                   Applications
//                                 </button>
//                               )}
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* === Modals === */}

//       {/* Assessment Form Modal */}
//       {showFormModal && selectedApplicant && (
//         <StaffAssessmentForm
//           applicant={selectedApplicant}
//           existingAssessment={editingAssessment}
//           currentUser={currentUser}
//           onClose={() => setShowFormModal(false)}
//           onSaved={refreshData}
//           BASE_URL={BASE_URL}
//         />
//       )}

//       {/* Applicant Details Modal */}
//       {showDetailsModal && selectedApplicant && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-3xl max-w-md w-full p-8">
//             <h2 className="text-2xl font-bold mb-6">Applicant Details</h2>
//             <div className="space-y-4">
//               <p><strong>Name:</strong> {getSeekerName(selectedApplicant)}</p>
//               <p><strong>Position:</strong> {selectedApplicant.position}</p>
//               <p><strong>Job:</strong> {selectedApplicant.job?.jobTitle || "—"}</p>
//               <p><strong>Status:</strong> {selectedApplicant.status}</p>
//             </div>
//             <button
//               onClick={() => setShowDetailsModal(false)}
//               className="mt-8 w-full py-3 bg-gray-900 text-white rounded-2xl hover:bg-black"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}

//       {/* View Full Assessment Modal - FIXED BUTTON */}
//       {showViewAssessmentModal && selectedAssessment && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-hidden">
//             <div className="p-6 border-b bg-orange-50">
//               <h2 className="text-2xl font-bold">Assessment Details</h2>
//               <p className="text-orange-700">
//                 {selectedAssessment.applicantName} - {selectedAssessment.positionApplied}
//               </p>
//             </div>

//             <div className="p-6 overflow-y-auto max-h-[65vh]">
//               <div className="grid grid-cols-2 gap-6 mb-8">
//                 <div>
//                   <p className="text-sm text-gray-500">Score</p>
//                   <p className="text-4xl font-bold">{selectedAssessment.percentageScore}%</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-gray-500">Level</p>
//                   <p className={`text-3xl font-bold ${getLevelColor(selectedAssessment.overallLevel).replace('bg-', 'text-')}`}>
//                     {selectedAssessment.overallLevel}
//                   </p>
//                 </div>
//               </div>

//               <p className="font-medium mb-2">Comments & Suggestions:</p>
//               <p className="text-gray-700 bg-gray-50 p-4 rounded-xl">
//                 {selectedAssessment.commentsAndSuggestions || "No comments provided."}
//               </p>
//             </div>

//             {/* Fixed View Applications Button */}
//             <div className="p-6 border-t bg-gray-50">
//               <button
//                 onClick={() => handleViewApplications(selectedAssessment.jobId || selectedAssessment.application?.job?._id)}
//                 className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3.5 rounded-2xl font-medium flex items-center justify-center gap-2 transition"
//               >
//                 <BiMessageAltAdd className="w-5 h-5" />
//                 View All Applications for this Job
//               </button>
//             </div>

//             <div className="p-6 border-t flex justify-end bg-white">
//               <button
//                 onClick={() => setShowViewAssessmentModal(false)}
//                 className="px-8 py-3 bg-gray-900 text-white rounded-2xl hover:bg-black"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StaffAssessmentPage;